import $ from 'jquery';



/* Layout toggle
********************************************/

if ($('.js-layout-toggles').length) {
	$('.js-layout-toggles a').on('click', function (e) {
		e.preventDefault();
		var $this = $(this);
		var layoutID = $this.attr('data-layout');

		if ( !$this.hasClass( 'is-selected' ) ) {
			$this.toggleClass('is-selected');
			$this.siblings().removeClass('is-selected');
			$this.closest('.js-layout-toggles').removeClass (function (index, className) {
				return (className.match (/(^|\s)has-selected-\S+/g) || []).join(' ');
			}).addClass('has-selected-' + layoutID + '')
		}
	});
}
